import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeneralSetting } from 'src/app/models/general-setting.model';
import { AuthService } from 'src/app/services/auth.service';
import { GeneralSettingsService } from 'src/app/services/general-settings.service';

@Component({
  selector: 'supporter-dialog',
  templateUrl: './supporter-dialog.component.html',
  styleUrl: './supporter-dialog.component.scss'
})
export class SupporterDialogComponent implements OnInit {
  public url: string;
  public isSupporter: boolean = this.data.isSupporter || false;

  constructor(
    private readonly authService: AuthService,
    private readonly generalSettingsService: GeneralSettingsService,
    private readonly dialogRef: MatDialogRef<SupporterDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      isSupporter: boolean;    
    },
  ) {}

  ngOnInit(): void {
    if(this.isSupporter) {
      this.getGiveAwayUrl().then((setting: GeneralSetting) => {
        this.url = setting.value;
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  async getGiveAwayUrl(): Promise<GeneralSetting> {
    try {
      const setting = await this.generalSettingsService.getGeneralSettingByKey(this.authService.authorizationHeaderValue, 'SupporterGiveAwayUrl')
      return setting;
    } catch (error: Error | any) {
      console.error('Error fetching supporter giveaway URL:', error);
    }
    return null;
  }
}
